
import Style from '../style/failedBox.module.scss'
import PerfectButtonRight from "../../../../assets/svg/PerfectButtonIconRight"
import PerfectButtonLeft from "../../../../assets/svg/PerfectButtonIconLeft"
import {useNavigate} from 'react-router-dom';

const FailedScreen = ({ h3Text = "", h5Text = "", h6Text = "", quizFaild = true }) => {
    const navigate = useNavigate();
    let route=quizFaild?'brandStore':'brandStore'
    return (
        <div className={Style.FaildBox}>
            <div className={Style.avatarBoxFialed} />
 
                <div className={Style.infoBox} style={{gap:!quizFaild&&"2px"}}>
                    {h3Text?.length > 0 && <p className={quizFaild?Style.FaildBoxText1:Style.FaildBoxText3}>{h3Text}</p>}
                    {h5Text?.length > 0 && <p className={quizFaild?Style.FaildBoxText2:Style.FaildBoxText4}>{h5Text}</p>}
                </div>
            
            <div className={Style.try_screen_botton} onClick={()=>navigate(`/${route}`)}><PerfectButtonRight /><p className={Style.try_button}>Try Again</p><PerfectButtonLeft /></div>
        </div>
    )
}

export default FailedScreen;